jQuery.ajaxSetup({
    xhrFields: {withCredentials: true}
});

jQuery(function ($) {
    'use strict';

    const header = $('.site-header');
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 12) {
            header.addClass('scrolled');
        } else {
            header.removeClass('scrolled');
        }
    });

    const menu_button = $('.mobile-menu-toggle');
    const mobile_menu = $('#mobileMenu');
    const close_button = $('.mobile-menu-close');
    const mobilemenu_backdrop = $('#mobileMenuBackdrop');

    /**
     * Opens the mobile menu by adding the necessary CSS classes to display it
     * and disables body scroll to enhance the user experience.
     *
     * @return {void} Does not return a value.
     */
    function openMenu() {
        mobile_menu.addClass('open');
        mobilemenu_backdrop.addClass('open');
        $('body').css('overflow', 'hidden');
    }

    /**
     * Closes the mobile menu by removing the 'open' class from the menu and backdrop elements.
     * Restores the body's overflow property to its default state.
     *
     * @return {void} This method does not return a value.
     */
    function closeMenu() {
        mobile_menu.removeClass('open');
        mobilemenu_backdrop.removeClass('open');
        $('body').css('overflow', '');
    }

    menu_button.on('click', openMenu);
    close_button.on('click', closeMenu);
    mobilemenu_backdrop.on('click', closeMenu);

    $(document).on('keydown', function (e) {
        if (e.key === "Escape") closeMenu();
    });

    /**
     * Retrieves the user data stored in the local storage under the 'wg_user' key.
     * Parses the stored JSON string into a JavaScript object if available, otherwise returns null.
     *
     * @return {Object|null} The parsed user object if it exists and is valid, or null if there's no data or an error occurs.
     */
    function getUser() {
        try {
            const raw = localStorage.getItem('wg_user');
            return raw ? JSON.parse(raw) : null;
        } catch (_) {
            return null;
        }
    }

    /**
     * Formats a user's name by combining their first and last names, or falls back to email or a default value.
     *
     * @param {Object} u - The user object containing name and email information.
     * @param {string} [u.first_name] - The user's first name.
     * @param {string} [u.last_name] - The user's last name.
     * @param {string} [u.email] - The user's email address, used if no name is present.
     * @return {string} The formatted name, or email if no name is provided, or "Account" as a default.
     */
    function formatName(u) {
        const first = (u?.first_name || '').trim();
        const last = (u?.last_name || '').trim();
        const full = (first + ' ' + last).trim().replace(/\s+/g, ' ');
        return full || (u?.email || 'Account');
    }

    $(function () {
        const $header = $('.header-right');
        const $login = $header.find('.login-link');
        const $acct = $header.find('.account-link');
        const $name = $acct.find('.account-name');

        const user = getUser();
        if (user) {
            $name.text(formatName(user));
            $login.hide();
            $acct.show();

        } else {
            $acct.hide();
            $login.show();
        }
    });

    // log out logic
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a[href="#log-out"]');
        if (!link) return;

        e.preventDefault();

        link.setAttribute('aria-disabled', 'true');
        fetch((window.WayGenAIGlobal?.apiBase || '/user') + '/logout', {
            method: 'POST',
            credentials: 'include'
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Logout failed');
                try {
                    localStorage.removeItem('wg_user');
                } catch (_) {
                }
                window.location.href = '/user/log-in/';
            })
            .catch(function () {
                link.removeAttribute('aria-disabled');
                window.alert(window.WayGenAIGlobal?.logoutError || 'Could not log out. Please try again.');
            });
    });
});

// mobile parallax
jQuery(function ($) {
    'use strict';

    // global settings
    const MOBILE_MAX = 700;                 // breakpoint for enabling mobile parallax
    const VIEWPORT_MARGIN = 120;            // viewport margin to skip far away blocks
    const RESIZE_DEBOUNCE_MS = 140;         // debounce delay for resize/orientationchange

    // map of all parallax blocks (can be extended)
    const PARALLAX_TARGETS = [
        {selector: '.page-hero-full', bgClass: 'page-hero-bg', factor: 0.25, fetchpriority: true},
        {selector: '.home-hero-full', bgClass: 'home-hero-bg', factor: 0.22, fetchpriority: true},
        {selector: '.home-parallax-cta', bgClass: 'home-parallax-bg', factor: 0.18},
        {selector: '.home-final-cta', bgClass: 'home-final-bg', factor: 0.16},
        {selector: '.pricing-hero-full', bgClass: 'pricing-hero-bg', factor: 0.24, fetchpriority: true},
        {selector: '.faq-hero-full', bgClass: 'faq-hero-bg', factor: 0.22, fetchpriority: true},
        {selector: '.posts-page-hero-full', bgClass: 'posts-page-hero-bg', factor: 0.22, fetchpriority: true},
        {selector: '.page-search-hero-full', bgClass: 'page-search-hero-bg', factor: 0.22, fetchpriority: true},
        {selector: '.status-hero-full', bgClass: 'status-hero-bg', factor: 0.22, fetchpriority: true},
    ];

    // system flags
    let isMobile = window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let enabled = false;       // is effect enabled
    let rafId = null;          // id of requestAnimationFrame
    let resizeTimer = null;    // debounce timer
    let hasListeners = false;  // are scroll/resize listeners attached

    // collect live elements once
    const targets = [];
    PARALLAX_TARGETS.forEach(cfg => {
        const $els = $(cfg.selector);
        if ($els.length) {
            $els.each(function () {
                targets.push({
                    el: this,
                    $el: $(this),
                    selector: cfg.selector,
                    bgClass: cfg.bgClass,
                    factor: cfg.factor,
                    fetchpriority: cfg.fetchpriority || false
                });
            });
        }
    });

    if (!targets.length) return; // no parallax elements on the page — exit

    /**
     * Extracts the first URL found inside a CSS `background-image` property value.
     *
     * @param {string} bg - The `background-image` string to be processed.
     * @return {string|null} Returns the first extracted URL wrapped in `url()`, or null if no URL is found.
     */
    function extractFirstUrl(bg) {
        // find the first url(...) in background-image
        const m = /url\((['"]?)(.*?)\1\)/i.exec(bg || '');
        return m ? `url("${m[2]}")` : null;
    }

    /**
     * Removes the first occurrence of a `url(...)` from a given background string,
     * preserving the rest of the string (including gradients or additional layers).
     *
     * @param {string} bg - The background string to process.
     * @return {string} The modified background string with the first `url(...)` removed.
     */
    function removeFirstUrl(bg) {
        if (!bg) return '';
        // remove only the first url(...), keep other layers (gradients, etc.)
        let removed = false;
        return bg
            .split(',')
            .map(s => s.trim())
            .filter(part => {
                if (!removed && /url\(/i.test(part)) {
                    removed = true;
                    return false;
                }
                return true;
            })
            .join(', ');
    }

    /**
     * Ensures that a background layer (with a specified class) exists in the element's DOM structure and moves the image layer to a new background element.
     *
     * @param {Object} t - An object containing the DOM element and related data. It must have the following properties:
     *   - `$el`: The jQuery/selector object representing the target DOM element.
     *   - `bgClass`: A string specifying the CSS class to be used for the background layer.
     * @return {void} Does not return any value.
     */
    function ensureBgLayer(t) {
        if (t.$el.find('.' + t.bgClass).length) return;

        const origBg = t.$el.css('background-image') || '';
        if (!origBg || origBg === 'none') return;

        const imgOnly = extractFirstUrl(origBg);
        const restBg = removeFirstUrl(origBg);
        if (!imgOnly) return; // no image — nothing to move

        // save full original background to restore on disable()
        t.$el.data('origBgImage', origBg);

        const attrs = {
            class: t.bgClass,
            'aria-hidden': 'true'
        };
        if (t.fetchpriority) {
            attrs.fetchpriority = t.fetchpriority;
        }
        const $bg = $('<div/>', attrs).css({
            'background-image': imgOnly,
            'will-change': 'transform',
            'pointer-events': 'none'
        });

        t.$el.prepend($bg);

        // keep the other background layers (gradients, etc.) in the parent
        if (restBg && restBg.length) {
            t.$el.css('background-image', restBg);
        } else {
            t.$el.css('background-image', 'none');
        }
    }

    /**
     * Destroys the background layer associated with the given object.
     *
     * @param {Object} t - The target object containing the element and background settings.
     * @return {void} This method does not return any value.
     */
    function destroyBgLayer(t) {
        const $bg = t.$el.find('.' + t.bgClass);
        if ($bg.length) $bg.remove();

        // restore the original background
        const orig = t.$el.data('origBgImage');
        if (orig !== undefined) {
            t.$el.css('background-image', orig);
            t.$el.removeData('origBgImage');
        }
    }

    /**
     * Updates the parallax effect for the specified targets by adjusting the background position
     * based on the scroll position and defined factor.
     *
     * It calculates the scroll offset, ensures elements are within the viewport range,
     * and applies a transform to their background elements for the parallax effect.
     *
     * @return {void} This function does not return a value.
     */
    function updateParallax() {
        rafId = null;
        if (!enabled) return;

        const scrollY = window.scrollY || window.pageYOffset;
        const winH = window.innerHeight || document.documentElement.clientHeight;

        for (let i = 0; i < targets.length; i++) {
            const t = targets[i];
            const el = t.el;
            const rect = el.getBoundingClientRect();
            const top = rect.top + scrollY;
            const height = rect.height || el.offsetHeight;

            // skip if far from viewport
            if (scrollY + winH + VIEWPORT_MARGIN < top || scrollY - VIEWPORT_MARGIN > top + height) continue;

            const offset = (scrollY - top) * t.factor;
            const bg = el.querySelector('.' + t.bgClass);
            if (bg) {
                bg.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        }
    }

    /**
     * Handles the scroll event by triggering a parallax update using requestAnimationFrame.
     * Ensures that the `updateParallax` function is not called multiple times during a single frame.
     *
     * @return {void} Does not return a value.
     */
    function onScroll() {
        if (!rafId) rafId = requestAnimationFrame(updateParallax);
    }

    /**
     * Attaches multiple event listeners to the window object for handling scroll, load, resize,
     * and orientation change events. Ensures that listeners are not added multiple times.
     *
     * @return {void} Does not return any value.
     */
    function addListeners() {
        if (hasListeners) return;
        window.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('load', updateParallax, {once: true});
        window.addEventListener('resize', onResizeDebounced, {passive: true});
        window.addEventListener('orientationchange', onResizeDebounced, {passive: true});
        hasListeners = true;
    }

    /**
     * Removes all registered event listeners from the window object, including
     * scroll, resize, and orientation change events. Updates the internal
     * state to reflect that no listeners are currently attached.
     *
     * @return {void} This method does not return a value.
     */
    function removeListeners() {
        if (!hasListeners) return;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResizeDebounced);
        window.removeEventListener('orientationchange', onResizeDebounced);
        hasListeners = false;
    }

    /**
     * Handles window resize events with a debounce mechanism to improve performance.
     * Executes the parallax update logic only if the feature is enabled and after a specified delay since the last resize event.
     *
     * @return {void} This function does not return a value.
     */
    function onResizeDebounced() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            if (enabled) {
                updateParallax();
            }
        }, RESIZE_DEBOUNCE_MS);
    }

    /**
     * Enables the functionality by ensuring background layers are created,
     * adding event listeners, and updating the parallax effect if it's not already enabled.
     *
     * @return {void} No return value.
     */
    function enable() {
        if (enabled) return;
        // create bg layers where not yet created
        for (let i = 0; i < targets.length; i++) {
            ensureBgLayer(targets[i]);
        }
        addListeners();
        enabled = true;
        updateParallax();
    }

    /**
     * Disables the feature or functionality by performing cleanup operations.
     * This includes removing event listeners, destroying background layers for targets,
     * canceling any ongoing animation frames, and updating the enabled state.
     *
     * @return {void} Does not return any value.
     */
    function disable() {
        if (!enabled) return;
        removeListeners();
        for (let i = 0; i < targets.length; i++) {
            destroyBgLayer(targets[i]);
        }
        if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
        enabled = false;
    }

    /**
     * Re-evaluates the state and determines whether to enable or disable a functionality
     * based on the conditions of being in a mobile breakpoint and not having reduced motion preferences.
     * Executes the enable function if conditions are met, otherwise executes the disable function.
     *
     * @return {void} Does not return a value.
     */
    function reevaluate() {
        // enable only if mobile breakpoint and no reduced motion
        const shouldEnable = isMobile && !prefersReducedMotion;
        if (shouldEnable) enable();
        else disable();
    }

    // initial initialization
    if (!prefersReducedMotion && isMobile) enable();

    // react to breakpoint changes
    const mq = window.matchMedia(`(max-width:${MOBILE_MAX}px)`);
    const mqHandler = (e) => {
        isMobile = e.matches;
        reevaluate();
    };
    if (mq.addEventListener) mq.addEventListener('change', mqHandler);
    else mq.addListener(mqHandler);

    // react to system animation preference changes
    const rmq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const rmqHandler = (e) => {
        // reevaluate on preference change
        reevaluate();
    };
    if (rmq.addEventListener) rmq.addEventListener('change', rmqHandler);
    else rmq.addListener(rmqHandler);
});

// BETA BANNER
jQuery(function ($) {
    'use strict';

    const COOKIE_NAME = 'wg_beta_ack';
    const DAYS = 7;
    const $overlay = $('#wg-beta-overlay');
    const $acceptBtn = $('#wg-beta-accept');

    /**
     * Sets a cookie with the specified name, value, and expiration duration in days.
     *
     * @param {string} name - The name of the cookie.
     * @param {string} value - The value to be stored in the cookie.
     * @param {number} days - The number of days until the cookie expires.
     * @return {void} Does not return a value.
     */
    function setCookie(name, value, days) {
        const maxAge = days * 24 * 60 * 60;
        const secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = name + '=' + encodeURIComponent(value) +
            '; Max-Age=' + maxAge +
            '; Path=/' +
            '; SameSite=Lax' +
            secure;
    }

    /**
     * Retrieves the value of a specified cookie by its name.
     *
     * @param {string} name - The name of the cookie to retrieve.
     * @return {string|null} The value of the cookie if found, or null if the cookie does not exist.
     */
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(?:^|; )' +
            name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
            '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    /**
     * Opens a popup by displaying the overlay element.
     *
     * @return {void} This function does not return a value.
     */
    function openPopup() {
        $overlay.show();
    }

    /**
     * Closes the popup by hiding the overlay and setting a cookie with a predefined expiration period.
     * This ensures the popup does not reappear until the cookie expires.
     *
     * @return {void} Does not return a value.
     */
    function closePopup() {
        setCookie(COOKIE_NAME, '1', DAYS);
        $overlay.hide();
    }

    // check and maybe show popup
    if (!$overlay.length) return;
    if (!getCookie(COOKIE_NAME)) {
        setTimeout(() => {
            openPopup();
        }, 1000);
    }

    $acceptBtn.on('click', closePopup);

    // close popup
    $overlay.on('click', function (e) {
        if ($(e.target).hasClass('beta-overlay__backdrop')) {
            closePopup();
        }
    });
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closePopup();
        }
    });
});
